import { Component, OnInit} from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../../_services/langhfre.service';
import { NavigationService } from 'src/app/_services/navigation.service';
//declare function ire(string,{}): any;

@Component({
  selector: 'app-process-model',
  templateUrl: './process-model.component.html',
  styleUrls: ['./process-model.component.scss']
})
export class ProcessModelComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    public navigationService: NavigationService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('打造您的專屬 AI 模型：逐步流程 | Trinka AI');
    this.metaTagService.updateTag({ name: 'description', content: "了解 Trinka AI 如何打造符合您需求的客製化 AI 模型從資料收集到安全部署，我們確保精準度、可擴展性與完整所有權" });
    this.metaTagService.updateTag({ property: 'og:title', content: "打造您的專屬 AI 模型：逐步流程 | Trinka AI" });
    this.metaTagService.updateTag({ property: 'og:description', content: "了解 Trinka AI 如何打造符合您需求的客製化 AI 模型從資料收集到安全部署，我們確保精準度、可擴展性與完整所有權" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/enterprise/custom-ai-models/process' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/enterprise/custom-ai-models/process' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '打造您的專屬 AI 模型：逐步流程 | Trinka AI' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "了解 Trinka AI 如何打造符合您需求的客製化 AI 模型從資料收集到安全部署，我們確保精準度、可擴展性與完整所有權" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/custom-ai-models/process' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/custom-ai-models/process' });

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
    // console.log("Country is", this.country);
  }

}
